/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationKey =
  () =>
    [
      {
        url: "/api/v1/individualpayment/financial-people/:financialPersonId/parcels/cancel-open",
      },
    ] as const;

export type PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationKey
  >;

export function postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ financialPersonId, data }) => {
      return postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen(
        financialPersonId,
        data,
        config,
      );
    },
  });
}

/**
 * @description Cancela as parcelas informadas que pertencem ao plano e estão pendentes ou aguardando integração. Migrado do legado IndividualPayment/CancelOpenParcels. **(Requer Authorization para autenticação)**
 * @summary Cancela parcelas abertas do plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/financial-people/:financialPersonId/parcels/cancel-open}
 */
export function usePostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
        | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
      >,
      {
        financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"];
        data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen401
      | PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpen500
    >,
    {
      financialPersonId: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenPathParams["financialPersonId"];
      data?: PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidParcelsCancelOpenMutationRequest;
    },
    TContext
  >;
}
